import { CallbackProperty, Cartesian3 } from "cesium";
import { PointProps } from "./point-edit-options";

/* NOTE: Extracted from angular-cesium with updated types  */

/* eslint-disable no-underscore-dangle */
export class EditPoint {
    private static counter = 0;
    private id: string;
    private editedEntityId: string;
    private position: Cartesian3;
    private virtualEditPoint: boolean;
    private pointProps: PointProps;
    private _show = true;

    constructor(entityId: string, position: Cartesian3, pointProps?: PointProps, virtualPoint = false) {
        this.editedEntityId = entityId;
        this.position = position;
        this.id = this.generateId();
        this.pointProps = { ...pointProps };
        this.virtualEditPoint = virtualPoint;
    }

    public get show() {
        return this._show;
    }

    public set show(value) {
        this._show = value;
    }

    public get props(): PointProps {
        return this.pointProps;
    }

    public set props(value: PointProps) {
        this.pointProps = value;
    }

    public isVirtualEditPoint(): boolean {
        return this.virtualEditPoint;
    }

    public setVirtualEditPoint(value: boolean) {
        this.virtualEditPoint = value;
    }

    public getEditedEntityId(): string {
        return this.editedEntityId;
    }

    public getPosition(): Cartesian3 {
        return this.position.clone();
    }

    public getPositionCallbackProperty(): CallbackProperty {
        return new CallbackProperty(this.getPosition.bind(this), false);
    }

    public setPosition(position: Cartesian3) {
        this.position.x = position.x;
        this.position.y = position.y;
        this.position.z = position.z;
    }

    public getId(): string {
        return this.id;
    }

    private generateId(): string {
        return "edit-point-" + EditPoint.counter++;
    }
}
